"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InitiateDNSSchema = exports.CommissionChains = exports.getPaymentOptions = exports.FIKSyntax = exports.paymentServiceProviders = exports.PaymentOptionType = exports.CollectorType = void 0;
const zod_1 = require("zod");
var CollectorType;
(function (CollectorType) {
    CollectorType["CREDITOR"] = "CREDITOR";
    CollectorType["TENANT"] = "TENANT";
})(CollectorType || (exports.CollectorType = CollectorType = {}));
var PaymentOptionType;
(function (PaymentOptionType) {
    PaymentOptionType["FI"] = "FI";
    PaymentOptionType["IBAN"] = "IBAN";
    PaymentOptionType["SWIFT"] = "SWIFT";
    PaymentOptionType["BANKTRANSFER"] = "BANKTRANSFER";
    PaymentOptionType["REEPAY"] = "REEPAY";
    PaymentOptionType["FARPAY"] = "FARPAY";
    PaymentOptionType["MOBILE_PEOPLE"] = "MOBILE_PEOPLE";
    PaymentOptionType["LINK_TO_OWN_PAYMENT"] = "LINK_TO_OWN_PAYMENT";
})(PaymentOptionType || (exports.PaymentOptionType = PaymentOptionType = {}));
exports.paymentServiceProviders = [
    PaymentOptionType.REEPAY,
    PaymentOptionType.FARPAY,
    PaymentOptionType.MOBILE_PEOPLE,
];
var FIKSyntax;
(function (FIKSyntax) {
    FIKSyntax["CaseIdAndZero"] = "CaseIdAndZero";
    FIKSyntax["PrincipalReferenceId"] = "PrincipalReferenceId";
})(FIKSyntax || (exports.FIKSyntax = FIKSyntax = {}));
const paymentOptionOrder = [
    PaymentOptionType.BANKTRANSFER,
    PaymentOptionType.FI,
    PaymentOptionType.SWIFT,
    PaymentOptionType.IBAN,
    PaymentOptionType.REEPAY,
    PaymentOptionType.FARPAY,
    PaymentOptionType.MOBILE_PEOPLE,
    PaymentOptionType.LINK_TO_OWN_PAYMENT,
];
const orderingIndex = (paymentOption) => Array.isArray(paymentOption)
    ? paymentOptionOrder.findIndex((k) => k === paymentOption.type)
    : -1;
const getPaymentOptions = (options, currency) => {
    options = options.sort((a, b) => orderingIndex(b) - orderingIndex(a));
    const filteredOptions = options.reduce((acc, option) => {
        if (option.currencies == null ||
            (Array.isArray(option.currencies) && option.currencies.includes(currency))) {
            if (acc[option.type] == null)
                acc[option.type] = option;
        }
        return acc;
    }, {});
    return Object.values(filteredOptions).sort((a, b) => orderingIndex(b) - orderingIndex(a));
};
exports.getPaymentOptions = getPaymentOptions;
var CommissionChains;
(function (CommissionChains) {
    CommissionChains["NcNp"] = "9860cf1a-b4d9-4d4e-a085-298c4781eca0";
    CommissionChains["NoCom"] = "22d11ef6-41cd-4e12-b9d0-f0678afde91b";
})(CommissionChains || (exports.CommissionChains = CommissionChains = {}));
exports.InitiateDNSSchema = zod_1.z.object({
    debtorWebBase: zod_1.z.string().optional(),
    creditorWebBase: zod_1.z.string().optional(),
    outboundEmail: zod_1.z.string().email(),
});
//# sourceMappingURL=index.js.map